import { useLocation } from 'react-router-dom';
import { legacyContentFor } from '../data/legacyContent';

export const LegacyAbout = () => {
  const { pathname } = useLocation();
  const c = legacyContentFor(pathname);
  if (!c) return null;
  return (
    <section className="py-16 bg-[#f6f7f5] border-t border-border" data-testid="legacy-about-section">
      <div className="container-custom max-w-4xl">
        <p className="text-primary text-xs font-bold uppercase tracking-widest mb-3">About Land Drafters, LLC</p>
        <h2 className="text-2xl md:text-3xl font-black uppercase tracking-tight mb-4" data-testid="legacy-about-heading">{c.heading}</h2>
        <p className="text-base text-muted-foreground leading-relaxed" data-testid="legacy-about-text">{c.text}</p>
      </div>
    </section>
  );
};
